import { InjectionToken } from '@angular/core';

export interface AuthConfig {
  groupNames: string[];
  adminGroupName?: string;
  rolesClaimKey?: string;
  /**
   * Scopes used when silently renewing an expired token via the refresh token.
   * Defaults to ['openid', 'profile'].
   */
  silentRequestScopes?: string[];
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');
